import React, { useState } from "react";
import {
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { CiMenuFries } from "react-icons/ci";
import { AiOutlineClose } from "react-icons/ai"; // Importing X icon
import { styled } from "@mui/material/styles";

const LinkStyle = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: "#fff",
  fontSize: "20px",
  // backgroundColor:'#0d2369',
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 20px",
  backgroundColor: "transprent", // Customize as needed
  color: "#000",
  [theme.breakpoints.down("sm")]: {
    padding: "5px 15px",
  },
}));

const DrawerComponent = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <>
      <Drawer
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        anchor="left"
      >
        <DrawerHeader>
          <img style={{width:'50%', margin:'auto'}} src="./images/SHIVA-OLD-LOGO2.png" alt="logo" />
          <IconButton onClick={() => setOpenDrawer(false)}>
            <AiOutlineClose size={24} style={{ color: "#0d2369" }} />
          </IconButton>
        </DrawerHeader>
        {/* <Divider /> */}
        <List>
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <LinkStyle to="/">HOME</LinkStyle>
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <LinkStyle to="/about">ABOUT US</LinkStyle>
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <LinkStyle to="/institutions">INSTITUTIONS</LinkStyle>
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <LinkStyle to="/vision">VISION</LinkStyle>
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <LinkStyle to="/gallery">GALLERY</LinkStyle>
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <LinkStyle to="/news">NEWS</LinkStyle>
            </ListItemText>
          </ListItem>
          <Divider />
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <LinkStyle to="/contact">CONTACT US</LinkStyle>
            </ListItemText>
          </ListItem>
          <Divider />
        </List>
      </Drawer>
      <IconButton
        onClick={() => setOpenDrawer(!openDrawer)}
        sx={{ color: "#000" }}
      >
        <CiMenuFries style={{color:'#0d2369'}} />
      </IconButton>
    </>
  );
};

export default DrawerComponent;
